import { RegistrationContainer } from '@bumble/app/components/RegistrationContainer';
import { useAccount } from '@bumble/app/hooks/use-account';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export const Authenticate = () => {
  const [showAuth, setShowAuth] = useState(true);
  const { authenticate } = useAccount();
  const [searchParams] = useSearchParams();
  const accessToken = searchParams.get('access_token');
  const tokenType = searchParams.get('token_type');
  const sessionType = searchParams.get('session_type');
  const username = searchParams.get('username') || '';

  useEffect(() => {
    if (accessToken && tokenType && sessionType && username) {
      authenticate({ access_token: accessToken, session_type: sessionType, username }, '/main-dashboard');
    } else {
      setShowAuth(false);
    }
  }, [accessToken, tokenType, sessionType]);

  return (
    <RegistrationContainer>
      <Typography variant="h3" component="p" py={2}>
        {showAuth ? 'Authenticating...' : 'Authentication failed'}
      </Typography>
      <Typography variant="body1" component="p" mb={4}>
        {showAuth ? 'Please wait while we authenticate your account. You will be redirected to your dashboard shortly.' : 'We could not authenticate your account, please close the page and try again.'}
      </Typography>
      <Box py={6}>
        <Divider />
      </Box>
      <Button size="small" variant="text" component={Link} to="/login">
        Login with account details?
      </Button>
    </RegistrationContainer>
  );
};
